import TicketsList from "@/features/tickets/TicketsList";
import TicketDetails from "@/features/tickets/TicketDetails";

export const ticketsRoutes = {
  path: "tickets",
  children: [
    {
      path: "",
      element: <TicketsList />,
    },
    {
      path: ":id",
      element: <TicketDetails />,
    },
  ],
};